import validate from "C:/repositories/optilink-parent/web-portal-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "C:/repositories/optilink-parent/web-portal-frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-authenticated": () => import("C:/repositories/optilink-parent/web-portal-frontend/middleware/isAuthenticated.ts"),
  "switch-layout": () => import("C:/repositories/optilink-parent/web-portal-frontend/middleware/switchLayout.ts")
}